<div
    bsModal
    #createOrEditModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #accountGroupForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span *ngIf="accountGroup.id">{{ l('EditAccountGroup') }}</span>

                        <span *ngIf="!accountGroup.id">{{ l('CreateNewAccountGroup') }}</span>
                    </h4>

                    <button
                        type="button"
                        class="btn-close"
                        (click)="close()"
                        aria-label="Close"
                        [disabled]="saving"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="my-3">
                        <label class="form-label" for="AccountGroup_Code">{{ l('Code') }} *</label>
                        <input
                            type="text"
                            #AccountGroup_Code="ngModel"
                            id="AccountGroup_Code"
                            class="form-control"
                            [(ngModel)]="accountGroup.code"
                            name="Code"
                            minlength="0"
                            maxlength="20"
                            required
                        />
                        <validation-messages [formCtrl]="AccountGroup_Code"></validation-messages>
                    </div>

                    <div class="my-3">
                        <label class="form-label" for="AccountGroup_Name">{{ l('Name') }}</label>
                        <input
                            type="text"
                            #AccountGroup_Name="ngModel"
                            id="AccountGroup_Name"
                            class="form-control"
                            [(ngModel)]="accountGroup.name"
                            name="Name"
                        />
                        <validation-messages [formCtrl]="AccountGroup_Name"></validation-messages>
                    </div>
                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-default" (click)="close()">
                        {{ l('Cancel') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!accountGroupForm.form.valid"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
